var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { DDQ } from '@api/utils';
import config from '@api/config';
var TrackingError = /*@__PURE__*/ (function () {
    function TrackingError() {
        this.eventName = 'error'; // * "validation","technical","authentication","notification"
    }
    TrackingError.prototype.setEventName = function (eventName) {
        this.eventName = eventName;
        return this;
    };
    TrackingError.prototype.setType = function (type) {
        this.type = type;
        return this;
    };
    TrackingError.prototype.setMessage = function (message) {
        this.message = message;
        return this;
    };
    TrackingError.prototype.setCode = function (code) {
        this.code = code;
        return this;
    };
    TrackingError.prototype.setLocation = function (location) {
        this.location = location;
        return this;
    };
    TrackingError.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                data = {
                    type: this.type,
                    message: this.message,
                    code: this.code,
                    location: this.location
                };
                if (config.TEALIUM_ENVIRONMENT) {
                    data.tealiumEnvironment = 'autotest';
                }
                return [2 /*return*/, data];
            });
        });
    };
    TrackingError.prototype.track = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            return __awaiter(_this, void 0, void 0, function () {
                var _a, _b, _c, listener;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            _b = (_a = DDQ).push;
                            _c = [this.eventName];
                            return [4 /*yield*/, this.getData()];
                        case 1:
                            _b.apply(_a, [_c.concat([_d.sent()])]);
                            listener = function () {
                                resolve();
                            };
                            if (!DDQ.on) {
                                resolve();
                                return [2 /*return*/];
                            }
                            DDQ.on('error', function () {
                                if (listener) {
                                    listener();
                                }
                                listener = null;
                            });
                            return [2 /*return*/];
                    }
                });
            });
        });
    };
    return TrackingError;
}());
export { TrackingError };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/services/tracking/tracking.error.ts
// module id = null
// module chunks = 